<template>
  <el-drawer
    v-model="showDrawer"
    ref="orderDrawer"
    size="1000px"
    custom-class="r-drawer"
    :close-on-click-modal="false"
    @open="showEditView = true"
    @close="handleClose"
  >
    <template #title>
      <div class="font-18 font-bold color-black">下发订单</div>
    </template>

    <EditView
      is-status
      :default-data="orderDefault"
      :detail-type="formType"
      :sel-options="dictList"
      :detail-modal="showEditView"
      @submitSuccess="submitSuccess"
      @closeModel="handleClose"
    />
  </el-drawer>
</template>

<script>
import { mapActions } from "vuex";
import EditView from "../../baseInfo/order/editView.vue";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dictList: {
      type: Object,
      default: () => ({})
    },
    defaultData: {
      type: Object,
      default: () => ({})
    }
  },
  components: { EditView },
  data() {
    return {
      formType: "add",
      orderDefault: {},

      showDrawer: false,
      showEditView: false,
    };
  },
  created() {
    this.showDrawer = this.value;
  },
  watch: {
    value(val) {
      this.showDrawer = val;
    },
    defaultData: {
      deep: true,
      immediate: true,
      handler() {
        this.buildDefaultData()
      }
    }
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 构建一波默认数据
    buildDefaultData() {
      if (!this.defaultData.dateVal) return

      this.orderDefault = {
        roomId: this.defaultData.parentProps.roomId,
        roomName: this.defaultData.parentProps.roomName,
        roomTypeId: this.defaultData.parentProps.roomTypeId,
        roomTypeName: this.defaultData.parentProps.roomTypeName,
        proposedCheckInTime: this.defaultData.fullDate,
      }
    },
    // 提交成功
    submitSuccess() {
      this.handleClose();
    },
    // 处理关闭弹层
    handleClose() {
      this.$emit("input", false);
      this.showEditView = false;
      this.$refs.orderDrawer.handleClose();
    },
  },
};
</script>